export const HOME = '/';
export const DASHBOARD = '/app';
export const CONFIRM_RESET_PASSWORD = '/confirm-reset-password';
